import { render, staticRenderFns } from "./Wheelset.vue?vue&type=template&id=ee901ce2&"
import script from "./Wheelset.vue?vue&type=script&lang=js&"
export * from "./Wheelset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports